import { v4 as uuidv4 } from 'uuid';
import { ScheduleTaskForm } from './types';

export const createEmptyScheduleTask = (): ScheduleTaskForm => ({

  id: uuidv4(),
  delay: 0,
  delaySeconds: 0,
  ifScript: null,
  metaScript: null,
  metaData: null,
  taskTemplate: null,

});

export const ensureMinScheduleTasks = (
  tasks: ScheduleTaskForm[] | undefined,
): ScheduleTaskForm[] => {

  if (!tasks || tasks.length === 0) {

    return [createEmptyScheduleTask()];

  }
  return tasks;

};
